import { CircularProgress } from '@mui/material';
import { getObjectListByPropertyValueArrayApi } from 'api/general';
import { getMeetingListFromAuthUserIdApi } from 'api/meeting';
import MeetingDataTable from 'app/components/DataTable/meeting/MeetingDataTable';
import { getFilteredUnits, isRoleCheckList } from 'app/utils/appHelpers';
import { MEETINGS } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setAllMeetingList, setAllMMList, setPageType } from 'stores/meeting';
import config from '../../../config';
import LoadingPopUp from 'app/components/LoadingPopup';

const ManagementMeeting = () => {

    const dispatch = useDispatch();


    const [loading, setLoading] = useState(false);
    const authUser = useSelector(state => state.auth.authUser);
    const { pageType, subType } = useParams(); // subType=undefined ise sol menüden geliyor dolu ise dashboarddan
    const filteredInsts = config.institutions.filter(item => item.inst !== "YK").map(item => item.inst);
    const allMMList = useSelector((state) => state.meeting.allMMList);
    const [pageTitle, setPageTitle] = useState("");
    const allAuthorizedUnits = useSelector((state) => state.auth.allAuthorizedUnits);

    useEffect(() => {
        const getAPI = async () => {

            try {
                subType === undefined ? setLoading(true) : setLoading(false);
                dispatch(setPageType(pageType))
                if (!(allMMList !== undefined && allMMList.length > 0)) {


                    const res = await getMeetingListFromAuthUserIdApi("management");
                    let allList = res.data;

                    dispatch(setAllMMList(allList));
                    dispatch(setAllMeetingList(allList));

                }

            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                subType === undefined ? setLoading(false) : setLoading(true);
            }
        };

        getAPI();
    }, [pageType, subType]);

    useEffect(() => {
        const getAPI = async () => {
            try {
                setLoading(true);
                let filteredList = [];
                let list = [];
                if (!(allMMList !== undefined && allMMList.length > 0)) { // dshdaki cardlara sol menüye tıklamadan gelirse bu liste dolduruluyor
                    const res = await getMeetingListFromAuthUserIdApi("management");
                    list = res.data;
                    dispatch(setAllMMList(list));
                    dispatch(setAllMeetingList(list));

                    if (pageType === "1") {
                        list = list.filter(x => x.inst === "YK");
                    } else if (pageType === "3") {
                        list = list.filter(x => x.inst !== "YK");
                    }
                } else { // önceden doldurulmuş liste
                    if (pageType === "1") {
                        list = allMMList.filter(x => x.inst === "YK");
                    } else if (pageType === "3") {
                        list = allMMList.filter(x => x.inst !== "YK");
                    }
                }


                if (subType === "review") {
                    filteredList = list.filter(x => x.statReview === 1 && x.statFinish === 0);
                } else if (subType === "vote") {
                    filteredList = list.filter(x => x.statVote === 1 && x.statFinish === 0);
                } else if (subType === "video") {
                    filteredList = list.filter(x => x.statVideoCall === 1 && x.statFinish === 0);
                } else if (subType === "allFinish") {
                    filteredList = list.filter(x => x.statFinish === 1);
                } else if (subType === "allOngoing") {
                    filteredList = list.filter(x => x.statFinish === 0);
                } else if (subType === "admin") {

                    let mlist = [];
                    mlist = await getObjectListByPropertyValueArrayApi(MEETINGS, "adminUserId", authUser.id);
                    mlist = mlist.data
                    mlist = mlist.filter(x => x.active === 1)// sadece aktif olanlar silinmemis olanlar


                    if (pageType === "1") {
                        mlist = mlist.filter(x => x.inst === 'YK')
                    } else if (pageType === "3") {
                        mlist = mlist.filter(x => filteredInsts.includes(x.inst));
                    }

                    filteredList = mlist.filter(x => x.adminUserId === authUser.id);
                    filteredList = getFilteredUnits(filteredList, allAuthorizedUnits);

                }
                else {
                    filteredList = list;
                }
                if (pageType === "1") {
                    dispatch(setAllMeetingList(filteredList));
                } else if (pageType === "3") {
                    dispatch(setAllMeetingList(filteredList));
                }

            } catch (error) {
                console.error("Filtreleme Hatası: ", error);
            } finally {

                const cardTitle = config.dashboardCarsInfo.find(card => card.name === subType);
                const instTitle = (pageType !== undefined && pageType === "1") ? "YK / " : "Kurul-Komisyon / "
                setPageTitle(cardTitle !== undefined ? instTitle + cardTitle.title : instTitle + "Toplantı Listesi")
                // await delay(10); // sayfa yeniden yüklenmiyordu bu kullandıma ama yeni eklemede meeting card çalışmıyordu kaldırdım

                setLoading(false);
            }
        }

        getAPI();
    }, [allMMList, pageType, subType]);

    const userRoles = authUser ? authUser.userRoles : [];

    const columnData = [
        { id: 'id', align: 'left', disablePadding: false, label: "ID" },
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unit', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon" },
        { id: 'meetingNo', align: 'left', disablePadding: true, label: "Toplantı No" },
        { id: 'pdate', align: 'center', disablePadding: true, label: "Tarih" },
        { id: 'adminUserId', align: 'center', disablePadding: true, label: "Toplantı Yöneticisi" },
        { id: 'decisionCount', align: 'center', disablePadding: true, label: "Gündem Sayısı" },
        { id: 'userList', align: 'center', disablePadding: true, label: "Üyeler" },
        { id: 'participantList', align: 'center', disablePadding: true, label: "Katılımcılar" },
        ...(isRoleCheckList(userRoles, [1, 370, 373, 369, 372])
            ? [{ id: 'buttons', align: 'left', disablePadding: true, label: "İşlemler" }]
            : []),
        { id: 'islemler', align: 'center', disablePadding: true, label: "" }
    ];



    return (
        <React.Fragment>

            <>
                <LoadingPopUp open={loading} />
                {!loading && <MeetingDataTable column={columnData} pageTitle={pageTitle} loading={loading} setLoading={setLoading} />}
            </>
        </React.Fragment>
    );
};

export default ManagementMeeting;